import React from "react";

const Edit = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Iconly/Regular/Light/Edit Square">
      <g id="Edit Square">
        <path
          id="Stroke 1"
          d="M11.4922 2.78912H7.75324C4.67824 2.78912 2.75024 4.96612 2.75024 8.04812V16.3621C2.75024 19.4441 4.66924 21.6211 7.75324 21.6211H16.5772C19.6622 21.6211 21.5812 19.4441 21.5812 16.3621V12.3341"
          stroke="#BE282D"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Stroke 3"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.82763 10.921L16.3006 3.44805C17.2316 2.51805 18.7406 2.51805 19.6716 3.44805L20.8886 4.66505C21.8196 5.59605 21.8196 7.10605 20.8886 8.03605L13.3796 15.545C12.9726 15.952 12.4206 16.181 11.8446 16.181H8.09863L8.19263 12.401C8.20663 11.845 8.43363 11.315 8.82763 10.921Z"
          stroke="#BE282D"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Stroke 5"
          d="M15.165 4.60266L19.731 9.16866"
          stroke="#BE282D"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </g>
  </svg>
);

export default Edit;
